module.exports = __webpack_public_path__ + "assets/eb7d742d3d0f9bf33e5735cc77eef5d8.mp3";